<template>
  <div class="device-list px">
    <!-- 上一个按钮 -->
    <button class="button-3d prev-button" @click="goPrev" :disabled="activeDeviceIndex === 0">
      <div class="button-top">
        <span class="arrow">❮</span>
      </div>
      <div class="button-bottom"></div>
      <div class="button-base"></div>
    </button>

    <swiper
      ref="swiper"
      class="list"
      :options="options"
      @touchEnd="onSwiper"
      @slideChangeTransitionEnd="onSwiper"
    >
      <swiper-slide v-for="(device, index) in deviceList" :key="'device_' + index">
        <div
          class="item"
          :class="{
            active: index === activeDeviceIndex,
          }"
          @click="onClick(device, index)"
        >
          <img class="device" :src="getDeviceImage(device)" />
          <div class="name">
            {{ deviceName[device.code] }}
          </div>
          <div class="next">
            <i class="iconfont iconarrow-right" />
          </div>
        </div>
      </swiper-slide>
    </swiper>

    <!-- 下一个按钮 -->
    <button
      class="button-3d next-button"
      @click="goNext"
      :disabled="activeDeviceIndex === deviceList.length - 1"
    >
      <div class="button-top">
        <span class="arrow">❯</span>
      </div>
      <div class="button-bottom"></div>
      <div class="button-base"></div>
    </button>
  </div>
</template>
<script>
import { mapState } from "vuex";
import "swiper/swiper-bundle.min.css";
import { parseAM35SN, getAM35DeviceImageKey } from "@/utils/businessUtils";
export default {
  computed: {
    ...mapState("assets", {
      images: "images",
    }),
    ...mapState("loader", {
      deviceName: "deviceName",
      systemInfo: "systemInfo",
      currentDevice: "currentDevice",
      activeDeviceIndex: "activeDeviceIndex",
    }),
    options() {
      return {
        initialSlide: this.activeDeviceIndex,
        speed: 400,
        mousewheel: true,
        // spaceBetween: 50,
        effect: "coverflow",
        coverflowEffect: {
          depth: 200, // 深度
          rotate: 0, // 旋转角度
          scale: 1,
          stretch: -150, // 拉伸度
          slideShadows: false, // 是否显示滑动阴影
        },
      };
    },
    deviceList() {
      return this.systemInfo.deviceList;
    },
  },
  methods: {
    getDeviceImage(device) {
      const { code, MouseSn } = device;
      if (!code) return "";
      let imageName = `device_${code.toLowerCase()}`;
      if (code === "am35") {
        imageName = getAM35DeviceImageKey(parseAM35SN(MouseSn)); //
      }
      if (code === "am35_d") {
        imageName = getAM35DeviceImageKey(parseAM35SN(MouseSn), true); // 为am35_d设备显示特定图片
      }
      console.log(
        `DeviceList getDeviceImage code:${code} MouseSn:${MouseSn} imageName:${imageName}`
      );
      return this.images[imageName] || "";
    },
    onSwiper(swiper) {
      this.$store.dispatch("loader/setActiveDeviceIndex", swiper.activeIndex);
    },
    // 上一个设备
    goPrev() {
      if (this.activeDeviceIndex > 0) {
        const newIndex = this.activeDeviceIndex - 1;
        this.$refs.swiper.$swiper.slideTo(newIndex);
        this.$store.dispatch("loader/setActiveDeviceIndex", newIndex);
      }
    },
    // 下一个设备
    goNext() {
      if (this.activeDeviceIndex < this.deviceList.length - 1) {
        const newIndex = this.activeDeviceIndex + 1;
        this.$refs.swiper.$swiper.slideTo(newIndex);
        this.$store.dispatch("loader/setActiveDeviceIndex", newIndex);
      }
    },
    onClick(device, index) {
      this.$store.dispatch("loader/setActiveDeviceIndex", index);
      this.$store.dispatch("loader/setCurrentDevice", { ...device });
      switch (device.code) {
        case "cyberblade":
          break;
        case "dongle":
          this.$router.replace(this.$paths.dongle);
          break;
        case "mouse":
          this.$router.replace(this.$paths.mouse);
          break;
        case "mousedongle":
          this.$router.replace(this.$paths.dongleMouse);
          break;
        case "magnetkey":
          this.$router.replace(this.$paths.magnetic);
          break;
        case "am35_d":
          this.$router.replace(this.$paths.mouseAM35);
          break;
        case "am35":
          this.$router.replace(this.$paths.mouseAM35);
          break;
        default:
          this.$router.replace(this.$paths.firmware);
          break;
      }
    },
  },
  mounted() {
    // if (this.deviceList.length === 0) {
    //   this.$router.replace(this.$paths.welcome);
    // }
  },
};
</script>
<style lang="scss" scoped>
.device-list {
  @include flex-center;
  min-height: inherit;
  color: #ffffff;
  overflow: hidden;
  padding-top: 80px;
  position: relative;

  // 3D 按钮样式
  .button-3d {
    appearance: none;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
    border: 0;
    min-width: 4em;
    min-height: 4em;
    background: transparent;
    cursor: pointer;
    transition: opacity 0.3s;
    display: flex;
    justify-content: center;
    align-items: center;

    &.prev-button {
      left: 50px;
    }

    &.next-button {
      right: 50px;
    }

    &:disabled {
      opacity: 0.3;
      cursor: not-allowed;
      pointer-events: none;
    }

    .button-top {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      z-index: 2;
      width: 65px;
      height: 65px;
      color: #fff;
      // text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
      // border-radius: 20px;
      // box-shadow: 0 0 15px rgba($primary-color, 0.3);
      transition: transform 0.3s, border-radius 0.3s, box-shadow 0.3s;

      .arrow {
        font-size: 32px;
        font-weight: bold;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
      }
    }

    &:active .button-top {
      border-radius: 10px 10px 8px 8px / 8px;
      transform: translateY(2px);
      // box-shadow: 0 0 10px rgba($primary-color, 0.5);
    }

    .button-bottom {
      position: absolute;
      z-index: 1;
      bottom: 4px;
      left: 4px;
      width: calc(100% - 8px);
      height: calc(100% - 10px);
      border-radius: 40px;
      transition: border-radius 0.2s, border 0.2s, box-shadow 0.2s;
    }

    &:hover:not(:disabled) .button-bottom {
      // border: solid 2px #8028f5;
      box-shadow: inset 0 0 0.15rem 0.1rem #4136f1;
    }

    .button-base {
      position: absolute;
      z-index: 0;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 40px;
      // box-shadow: 0 1px 1px 0 rgba($primary-color, 0.2),
      //   inset 0 2px 2px rgba(0, 0, 0, 0.4);
      transition: border-radius 0.2s;
    }

    &:active .button-bottom {
      border-radius: 10px 10px 8px 8px / 8px;
    }

    &:active .button-base {
      border-radius: 10px 10px 8px 8px / 8px;
    }

    &:hover:not(:disabled) .button-top {
      // box-shadow: 0 0 25px rgba($primary-color, 0.8),
      //   0 0 40px rgba(#4136f1, 0.4);
    }
  }

  .list {
    width: 400px;
    height: 670px;
    overflow: visible;
    margin: 0 auto;
    position: relative;

    .item {
      width: 100%;
      height: 100%;
      background: #0d0d0d;
      border: solid 2px transparent;
      border-radius: 30px;
      position: relative;
      cursor: pointer;
      transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);

      img {
        width: 100%;
        position: absolute;
        top: 30%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
      }

      .name {
        width: 100%;
        text-align: center;
        font-size: 30px;
        margin-top: 450px;
      }

      .next {
        @include flex-center;
        width: 50px;
        height: 50px;
        position: absolute;
        background-image: $linear-gradient;
        border-radius: 100%;
        position: absolute;
        left: 50%;
        bottom: 80px;
        margin-left: -25px;
        opacity: 0;
        transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);

        .iconfont {
          margin-left: 6px;
          font-size: 20px;
          line-height: 50px;
          font-weight: bold;
        }
      }

      &.active,
      &:hover,
      &:active,
      &:focus {
        border: solid 2px $primary-color;
        box-shadow: inset 0 0 15px 10px #4136f1;

        img {
          width: 140%;
          max-width: none;
        }

        .next {
          opacity: 1;
        }
      }
    }
  }

  .dongle {
    width: 80px;
    height: 80px;
    line-height: 80px;
    position: fixed;
    right: 30px;
    bottom: 30px;
    color: #ffffff;
    text-align: center;
    cursor: pointer;

    &.active,
    &:hover {
      color: $primary-color;
    }

    .iconfont {
      font-size: 50px;
    }
  }
}
</style>
<style lang="scss">
.device-list {
  .list {
    .swiper-slide-shadow-left,
    .swiper-slide-shadow-right {
      border-radius: 30px;
    }

    .swiper-slide {
      width: 100% !important; /* 强制滑块使用100%宽度 */
      min-width: 300px; /* 设置最小宽度 */
    }
  }
}
</style>
